<template>
  <div
    class="flex flex-grow rounded-md border p-0"
    :class="customClass"
    @click="$emit('click')"
  >
    <label
      class="container-radio group w-full"
      :class="{
        'container-radio': checked,
        'pl-12': useRadio,
        'justify-center': !useRadio,
      }"
    >
      <input
        v-if="useRadio"
        type="radio"
        class="absolute cursor-pointer opacity-0"
        :name="radioName"
        :value="radioValue"
        :checked="checked"
        :disabled="disabled"
      />
      <span
        v-if="useRadio"
        class="checkmark border border-transparent"
        :class="
          !checked
            ? 'group-hover:border-light-gray group-hover:bg-light-gray'
            : ''
        "
      ></span>

      <div class="flex flex-col">
        <slot />
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'StyledButton',
  emits: ['click'],
  props: {
    checked: Boolean,
    useRadio: {
      type: Boolean,
      default: false,
    },
    radioName: String,
    radioValue: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customClass() {
      if (this.checked && this.useRadio) return 'activeButton';
      if (this.checked)
        return 'bg-pressed-gray text-neutral-subtle-bold border-pressed-gray';

      if (this.useRadio) {
        return 'border-transparent bg-off-white hover:border-body-color hover:text-gray-over-dark active:border-body-color active:text-body-color';
      }

      return 'border-transparent bg-off-white hover:bg-hovered-gray hover:text-neutral-subtle-bold active:bg-pressed-gray active:text-neutral-subtle-bold';
    },
  },
};
</script>

<style scoped>
.container-radio {
  @apply relative block flex h-full cursor-pointer items-center text-left text-sm text-body-color;
  min-height: 60px;
}
.container-radio input {
  position: absolute;
  height: 0;
  width: 0;
}

.checkmark {
  @apply absolute left-2 h-6 w-6 rounded-full bg-white;
  top: 50%;
  transform: translateY(-50%);
}
input:checked ~ .checkmark {
  @apply border-yellow-500 bg-yellow-500;
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}
input:checked ~ .checkmark:after {
  display: block;
  left: 0.43rem;
  top: 0.475rem;
  width: 0.5rem;
  height: 0.5rem;
  background-color: white;
  border-radius: 9999px;
}

.activeButton {
  @apply border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}
</style>
